import { jsPDF } from "jspdf";
import recibo from "../../../../utils/recibo.jpg";
import NumerosALetras from "../../../../utils/NumeroALetras";

/**
 * Genera el PDF de recibo con fuente unificada y control fino de interlineado.
 */
export default function pdfrecibo(props) {
  const {
    nombrepaciente,
    NombreUsuario,
    total,
    idrec,
    inicio,
    fin,
    fechacreacion
  } = props;
  const Sumatotal = total;
  const doc = new jsPDF();

  const FONT_SIZE = 10;
  const FONT_FAMILY = "helvetica";
  const FONT_STYLE = "normal";

  // Factor de separación entre líneas (más pequeño = menos espacio)
  const LINE_SPACING_FACTOR = 0.38; // Ajusta aquí (ej. 0.45 - 0.55)

  const today = new Date(fechacreacion);
  const letraOriginal = NumerosALetras(Sumatotal);

  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1;
  let dd = today.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const formattedToday = `${dd}/${mm}/${yyyy}`;

  doc.addImage(`${recibo}`, "JPEG", 0, 0, 210, 300);

  const setFont = () => {
    doc.setFont(FONT_FAMILY, FONT_STYLE);
    doc.setFontSize(FONT_SIZE);
    // Si quisieras forzar un factor global (afecta métodos internos de jsPDF):
    // doc.setLineHeightFactor(1.0);
  };

  const formatText = (txt) => {
    if (txt === null || txt === undefined) return "";
    const base = txt.toString().toLowerCase();
    return base.replace(/[\p{L}\p{M}]+/gu, (word) =>
      word.charAt(0).toUpperCase() + word.slice(1)
    );
  };

  const nombreUsuarioFmt = formatText(NombreUsuario);
  const nombrePacienteFmt = formatText(nombrepaciente);
  const letraFmt = formatText(letraOriginal);
  const conceptoFmt = formatText(`${nombrepaciente} del ${inicio} al ${fin}`);

  setFont();

  // --- BLOQUE SUPERIOR ---
  doc.text(`${idrec}`, 20, 22);
  doc.text(nombreUsuarioFmt, 70, 22);
  doc.text(`${SuministrarMiles(Sumatotal)} Gs.`, 100, 40);
  wrapText(doc, letraFmt, 90, 52, 100, FONT_SIZE + 2, LINE_SPACING_FACTOR);
  wrapText(doc, conceptoFmt, 90, 63, 100, FONT_SIZE + 2, LINE_SPACING_FACTOR);
  doc.text(`${formattedToday}`, 13, 142.5);

  // --- BLOQUE INFERIOR ---
  const OFFSET_Y = 150;
  doc.text(`${idrec}`, 20, 22 + OFFSET_Y);
  doc.text(nombreUsuarioFmt, 75, 22 + OFFSET_Y);
  doc.text(`${SuministrarMiles(Sumatotal)} Gs.`, 100, 40 + OFFSET_Y);
  wrapText(doc, letraFmt, 90, 52 + OFFSET_Y, 100, FONT_SIZE + 2, LINE_SPACING_FACTOR);
  wrapText(doc, conceptoFmt, 90, 63 + OFFSET_Y, 100, FONT_SIZE + 2, LINE_SPACING_FACTOR);
  doc.text(`${formattedToday}`, 13, 142.5 + OFFSET_Y);

  const totalPagesExp = "{total_pages_count_string}";
  if (typeof doc.putTotalPages === "function") {
    doc.putTotalPages(totalPagesExp);
  }

  doc.output("dataurlnewwindow");
  // doc.save(`recibo_${idrec}.pdf`);
}

/**
 * Envuelve texto con control de ancho e interlineado.
 * @param {jsPDF} doc
 * @param {string} text
 * @param {number} x
 * @param {number} y
 * @param {number} maxWidth
 * @param {number} lineHeight Altura base (puede ser fontSize o fontSize+algo)
 * @param {number} spacingFactor Multiplica lineHeight para separar (<=1)
 */
function wrapText(doc, text, x, y, maxWidth = 100, lineHeight = 12, spacingFactor = 0.6) {
  if (!text) return;
  const words = text.split(/\s+/);
  let line = "";
  const lines = [];

  for (let i = 0; i < words.length; i++) {
    const testLine = line ? line + " " + words[i] : words[i];
    const testWidth = doc.getTextWidth(testLine);
    if (testWidth > maxWidth) {
      if (line) lines.push(line);
      line = words[i];
    } else {
      line = testLine;
    }
  }
  if (line) lines.push(line);

  lines.forEach((ln, idx) => {
    doc.text(ln, x, y + idx * (lineHeight * spacingFactor));
  });
}

/**
 * Formatea números con separador de miles estilo "es-PY".
 */
function SuministrarMiles(n) {
  if (isNaN(n)) return "0";
  return Number(n).toLocaleString("es-PY");
}

/**
 * Genera y retorna el documento PDF de recibo sin abrirlo automáticamente.
 * Usado para integración con Tauri.
 */
export function generateReciboDocument(props) {
  // TODO: Esta es una implementación temporal/WIP
  // Similar a pdfrecibo pero retorna el doc en lugar de abrir en nueva ventana
  throw new Error("generateReciboDocument - WIP: needs full implementation");
}